import { Component, inject, signal, ElementRef, viewChild, AfterViewChecked, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HelpPanelService } from './help-panel.service';
import { HpMarkdownPipe } from './hp-markdown.pipe';
import { SkeletonComponent } from 'src/app/shared/components/skeleton/skeleton.component';

@Component({
  selector: 'app-help-panel',
  standalone: true,
  imports: [CommonModule, FormsModule, HpMarkdownPipe, SkeletonComponent],
  templateUrl: './help-panel.component.html',
  styleUrls: ['./help-panel.component.scss'],
})
export class HelpPanelComponent implements AfterViewChecked {
  readonly helpService = inject(HelpPanelService);
  readonly chatContainer = viewChild<ElementRef>('chatContainer');

  chatInput = '';
  private resizing = false;
  private startX = 0;
  private startWidth = 0;
  private shouldScroll = false;

  ngAfterViewChecked(): void {
    if (this.shouldScroll) {
      const el = this.chatContainer()?.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
      this.shouldScroll = false;
    }
  }

  onSend(): void {
    if (!this.chatInput.trim()) return;
    this.helpService.sendMessage(this.chatInput);
    this.chatInput = '';
    this.shouldScroll = true;
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSend();
    }
  }

  retry(): void {
    this.helpService.fetchSummary();
  }

  // Resize logic
  onResizeStart(event: MouseEvent): void {
    event.preventDefault();
    this.resizing = true;
    this.startX = event.clientX;
    this.startWidth = this.helpService.panelWidth();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (!this.resizing) return;
    const diff = this.startX - event.clientX;
    const newWidth = Math.min(600, Math.max(280, this.startWidth + diff));
    this.helpService.setWidth(newWidth);
  }

  @HostListener('document:mouseup')
  onMouseUp(): void {
    this.resizing = false;
  }
}
